import { getServiceMethodKey, GLServiceBase, HttpMethod, ServerExceptionCode, ServiceRoute } from "commonui";
import { MasterConversationType } from ".";
import { IConversationTemplateService } from "./interface";
import {
	CommonEntityResponseModel,
	CommonIntentDetailsModel,
	CommonIntentListModel,
	ConversationAssocResponseModel,
	ConversationTagResponseModel,
	ConversationTemplateModel,
	EntityDetailsModel,
	UtteranceEntitiesModel
} from "./model";

class ConversationTemplateServiceClass extends GLServiceBase<any, any> implements IConversationTemplateService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/conversations/templates" };

	getTemplates(params: { types: MasterConversationType[] }): Promise<ConversationTemplateModel[]> {
		return this.get(params);
	}

	createTemplate(data: ConversationTemplateModel): Promise<number> {
		return this.create(data);
	}

	updateTemplate(data: ConversationTemplateModel): Promise<any> {
		return this.update(data);
	}

	deleteTemplate(id: number): Promise<any> {
		return this.delete("{id}", null, { id });
	}

	getConversationTags(): Promise<ConversationTagResponseModel[]> {
		return this.get("tags");
	}

	getCompletedConvRefs(conversationId: number): Promise<ConversationAssocResponseModel[]> {
		return this.get("{conversationId}/completedrefs", null, { conversationId });
	}

	getConvTemplateRefs(conversationId: number): Promise<ConversationAssocResponseModel[]> {
		return this.get("{conversationId}/templateRefs", null, { conversationId });
	}

	getEntities(): Promise<UtteranceEntitiesModel[]> {
		return this.get("commonentities");
	}

	getEntityDetails(id: number): Promise<EntityDetailsModel> {
		return this.get("entitydetails", { entityId: id });
	}

	saveUpdateEntity(details: EntityDetailsModel): Promise<boolean> {
		return this.request.post(this.url("saveupdate/entity"), details);
	}

	deleteEntity(id: number): Promise<boolean> {
		return this.delete("{entityId}/deleteentity", null, { entityId: id });
	}

	getCommonIntents(): Promise<CommonIntentListModel[]> {
		return this.get("commonintents");
	}

	getCommonIntentDetails(id: number): Promise<CommonIntentDetailsModel> {
		return this.get("commonintentdetails", { intentId: id });
	}

	saveUpdateCommonIntent(details: CommonIntentDetailsModel): Promise<boolean> {
		return this.request.post(this.url("saveupdate/commonintent"), details);
	}

	deleteCommonIntent(id: number): Promise<boolean> {
		return this.delete("{intentId}/deletecommonintent", null, { intentId: id });
	}

	getcommonEntitiesList(): Promise<CommonEntityResponseModel[]> {
		return this.get("commonentities/list");
	}
}

export const ConversationTemplateService = () => new ConversationTemplateServiceClass() as IConversationTemplateService;
